import React from 'react';
import { Grid, PageLoading, SpaceWrapper, StickyNavigation } from '../../ui-toolkit';
import type { FCWithChildren } from '../../types/FCWithChildren';

export const VendorWrapper: FCWithChildren<{ isLoading: boolean }> = ({ children, isLoading }) => (
  <>
    <StickyNavigation hideActions />
    <SpaceWrapper>
      <Grid>{children}</Grid>
    </SpaceWrapper>
    <PageLoading isLoading={isLoading} />
  </>
);
